import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as GoogleIcon } from 'assets/icons/googleLogo.svg';
import { ReactComponent as MicrosoftIcon } from 'assets/icons/microsoft.svg';
import { CalendarTypes } from 'types';

import { Calendar, EmptyState } from '../../components';
import { useCalendar } from './hooks';
import {
  ContainerW,
  DaysW,
  HeaderW,
  IconButtonW,
  InnerContainer,
  OpenCalendarButton,
  SectionTitle,
  Title,
  TitleRow,
} from './styled';

export function CalendarPreview(): ReactElement {
  const { t } = useTranslation();
  const {
    isFetching,
    events,
    datesRange,
    monthLabel,
    selectedDate,
    setSelectedDate,
    handleGoogleSignIn,
    handleMicrosoftSignIn,
    groupedEvents,
    calendarLink,
    eventsProvider,
  } = useCalendar();

  const datesButtons = datesRange.map((day) => (
    <IconButtonW
      key={day}
      disabled={!events}
      isActive={day === selectedDate}
      onClick={() => setSelectedDate(day)}
    >
      <>{new Date(day).getDate()}</>
    </IconButtonW>
  ));

  const CalendarIcon =
    eventsProvider === CalendarTypes.google ? (
      <GoogleIcon width={18} height={18} />
    ) : (
      <MicrosoftIcon width={18} height={18} />
    );

  return (
    <ContainerW>
      <TitleRow>
        <SectionTitle>{t('calendar.title')}</SectionTitle>
        <OpenCalendarButton href={calendarLink} target="_blank" rel="noopener noreferrer">
          {CalendarIcon}
          {t('calendar.openCalendar')}
        </OpenCalendarButton>
      </TitleRow>
      <InnerContainer>
        <HeaderW>
          <Title>{t(`months.${monthLabel}`)}</Title>
          <DaysW>{datesButtons}</DaysW>
        </HeaderW>

        {events === null ? (
          <EmptyState
            handleGoogleSignIn={handleGoogleSignIn}
            handleMicrosoftSignIn={handleMicrosoftSignIn}
            isLoading={isFetching}
          />
        ) : (
          <>
            <Calendar events={groupedEvents[selectedDate]} selectedDate={selectedDate} />
          </>
        )}
      </InnerContainer>
    </ContainerW>
  );
}
